import { PropsWithChildren } from "react";
import { useAppSelector } from "../hooks/redux";
import { UserRole } from "../types/userProfile";

interface AccessProps extends PropsWithChildren {
  roles: UserRole[];
}
const Access: React.FC<AccessProps> = ({ roles, children }) => {
  const currentUserRole = useAppSelector(state => state.userProfile.data?.role);

  if (!currentUserRole || !roles.includes(currentUserRole)) {
    return null;
  }

  return <>{children}</>;
};

export default Access;
